// Module name
export const BUSINESS_MODULE = 'business';

// State fields
export const COMPLIANCE = 'compliance';
export const ACCOUNTS_RECEIVABLE = 'accountsReceivable';
export const SELF_EMPLOYMENT = 'selfEmployment';
export const MERCHANT_ACCOUNTS = 'merchantAccounts';

// Mutations
export const SET_PARAM = 'setParam';
export const SET_SELF_EMPLOYMENT_PARAM = 'setSelfEmploymentParam';
export const SET_ACCOUNTS_RECEIVABLE = 'setAccountsReceivable';
export const SET_MERCHANT_ACCOUNTS = 'setMerchantAccounts';
export const SET_INITIAL_COMPLIANCE = 'setInitialCompliance';
export const SET_INITIAL_BUSINESS_INFO = 'setInitialBusinessInfo';

// Actions
export const CHECK_COMPLIANCE = 'checkCompliance';
export const SET_COMPLIANCE = 'setCompliance';
export const SET_SELF_EMPLOYMENT = 'setSelfEmployment';
export const RESET_SELF_EMPLOYMENT = 'resetSelfEmployment';
export const FETCH_SELF_EMPLOYMENT = 'fetchSelfEmployment';
export const FETCH_ACCOUNTS_RECEIVABLE = 'fetchAccountsReceivable';
export const FETCH_ACCOUNT_RECEIVABLE_DETAILS = 'fetchAccountReceivableDetails';
export const UPDATE_ACCOUNT_RECEIVABLE = 'updateAccountReceivable';
export const ADD_ACCOUNT_RECEIVABLE = 'addAccountReceivable';
export const DELETE_ACCOUNT_RECEIVABLE = 'deleteAccountReceivable';
export const FETCH_MERCHANT_ACCOUNT = 'fetchMerchantAccount';
export const ADD_MERCHANT_ACCOUNT = 'addMerchantAccount';
export const DELETE_MERCHANT_ACCOUNT = 'deleteMerchantAccount';
export const FETCH_MERCHANT_ACCOUNT_DETAILS = 'fetchMerchantAccountDetails';
export const UPDATE_MERCHANT_ACCOUNT = 'updateMerchantAccount';
export const MARK_AS_COMPLETE = 'markAsComplete';
export const FETCH_PROFILE_DATA = 'fetchProfileData';

// Getters
export const GET_FORM_STEPS = 'getFormSteps';
export const IS_SELF_EMPLOYMENT_VALID = 'isSelfEmploymentValid';
